import React, { useEffect, useState } from "react";
import "react-datepicker/dist/react-datepicker.css";
import useHttp from "../../../hook/use-http";
import { API_URL_MAIN } from "../../../constants/driveglobalfilterinitalstates";
import { useSelector } from "react-redux";
import { selectLoggedInUser } from "../../../redux/userSlice";

function VehicleDetails({ gloablfilter, title }) {
  const { isLoading, error, sendReq: fetchData } = useHttp();
  const [vehicleDetails, setVehicleDetails] = useState([]);

  const appyData = (data) => {
    setVehicleDetails(data);
  };

  useEffect(() => {
    fetchData(
      {
        url: API_URL_MAIN + "real_time_fault_code/range_polygon",
        body: { filterdata: gloablfilter },
      },
      appyData
    );
  }, [gloablfilter]);

  const openGoogleUrl = () => {
    const newURL = `https://www.google.com/maps/search/${vehicleDetails?.gpsLat},${vehicleDetails?.gpsLong}?sa=X&ved=1t:242&ictx=111`
    window.open(newURL, "_blank");
  }

  const loggedInUser = useSelector(selectLoggedInUser);

  return (
    <>
      <div className="v-title boxDIC borderDownDIC p-0 indicator_lamp">
        <div className="boxTitleDIC pb-2 pt-2">{title}</div>
        {/* <div className="text-start p-4"> */}
        <div className="text-start px-4 py-3">
          <div className="py-2">
            <label className="vehicle_details_data fw-bold d-block">Registration Number</label>
            <span className="font-weight-bold fs-6">{vehicleDetails?.vehicle_registration_number || "-"}</span>
          </div>
          <div className="py-2">
            <label className="vehicle_details_data fw-bold d-block">VIN</label>
            <span className="font-weight-bold fs-6">{vehicleDetails?.vehicleId || "-"}</span>
          </div>
          <div className="py-2">
            <label className="vehicle_details_data fw-bold d-block">Model</label>
            <span className="font-weight-bold fs-6">{vehicleDetails?.PL || "-"}</span>
          </div>
          <div className="py-2">
            <label className="vehicle_details_data fw-bold d-block">Sim Status</label>
            <span className="font-weight-bold fs-6">{vehicleDetails?.sim_status || "-"}</span>
          </div>
          {/* <div className="py-2">
            <label className="vehicle_details_data fw-bold d-block">Distance to service</label>
            <span className="font-weight-bold fs-6">{vehicleDetails?.[0]?.fields?.Distance_to_service || "-"}</span>
          </div> */}
          <div className=" row py-2">
            <div className="col-6">
              <label className="vehicle_details_data fw-bold d-block">Trip A</label>
              <span className="font-weight-bold fs-6">{vehicleDetails?.Trip_A || "-"}</span>
            </div>
            <div className="col-6 position-relative">
              <label className="vehicle_details_data fw-bold d-block">
                Trip B
              </label>
              <span className="font-weight-bold fs-6">{vehicleDetails?.Trip_B || "-"}</span>
            </div>

          </div>
          <div className="row py-2">
            <div className="col-6">
              <label className="vehicle_details_data fw-bold d-block">Latitude</label>
              <span className="font-weight-bold fs-6">{vehicleDetails?.gpsLat || "-"}</span>
            </div>
            <div className="col-6 position-relative">
              <label className="vehicle_details_data fw-bold d-block">
                Longitude
                <div className="position-absolute top-0 end-0" style={{ transform: "translate(-250%, -50%)", cursor: "pointer" }}>
                  <img onClick={openGoogleUrl}
                    src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAIAAAACACAYAAADDPmHLAAAABHNCSVQICAgIfAhkiAAAAAlwSFlzAAADsQAAA7EB9YPtSQAAABl0RVh0U29mdHdhcmUAd3d3Lmlua3NjYXBlLm9yZ5vuPBoAAAZLSURBVHic7Z3La11VFIe/NJKk2MSR2ibNSCMIvjJQHIlKJU5Eq3TgC9H/QAQRqQXrzFd1EKytAwcWJ2qpA1snio4F8VEMiq3GNEkbCyZG0pQk18FOMMSb3L32Ofuex/59sGb7nLP2Xr+7X+fctUEIIYQQQgghhBBCCFF/Ogp4Zg8wBFwLXAl0tfHZ08A3wEIO99oFDOPqUCTzwLe4upWSbmAvcBgYA5aBRoE2B+wHOgPrMwCcAFYKrsd6WwaOA/2BdYrCIHAIuEjxDdTMjmHvAQeA8RL4vpmNUwIRXAW8DSxSfIO0sseMdTtRAp9b2SfGOuXKCDDZxKmy2leGuvVTrm5/M1sGdvpWapuhAbaiAzgIfIabHFWFYUPZWyhm0mxlG3Crb+ErcnhgJ3AUeDqHe7WbRtEORKLPt2DWHqCD6gYf3PLJl+9wQ0CtyCqAl6lu8MEtTX2ZAj6N5UgVGaH4NX0W+wD7mN5PuZeBa7bPWC8zfVRrtr/eZoEXCe/9+nFLrTKL31sAoZPAg4TP9meBk8BpYAL4J/A+Vhr8txV8KcN9JoGHcUut24De7K4Bbnv8FfJbmUVjkLBNnjO4jZd27v1XhSHgHBUZAt4KcGgUBX4zhnA9YSFDgJVu7Hv7z8VypgbECH5UAew1OjIay5EaECv4UQXwrsGJM7geQ/yfmMGPKoAxgxPWN22pEDv40QSwHf+1719o0teMLMG37Dt4C8Cy5rzeUP4kcNlw7xQYAr7EfVRiZRJ4KV93HBYBXGMo+4PVkZqTJfjTwB7gl1w9WsUigB2GslNWR2pM1uDfC/yUq0frsAjAMqbPWx2pKaUOPlRg37nClD74IAHEohLBBwkgBpUJPkgAeVOp4IMEkCeVCz5IAHlRyeCDBJAHlQ0+SABZqXTwQQLIQuWDDxJAKLUIPkgAIdQm+CABWKlV8EECsFC74IME4Estgw8SgA+1DT5IAK0oU/D/NpSd9S0oAWxOluCfA+4i31++b36CFeB735tKAM3JGvx7yP8bPt/8BMeJlDNwHyX4Y0IbyPLp9sTq9bFolZ/gdyLmaEpBAGUO/hrN8hMsAx8TEPw8kkTVhTJ2+83YmJ8AXK6j87EfXOceIMsvfwq4sf0u54MmgeVa6rWd1AWQdPAhbQEkH3xIVwAK/iopCkDBX0dqy8B+4AvKv9RrG6n1AKPA7oDrahl8SEsA/cCDAddNA/dRw+BDWgIYxp4buHZj/kZSEkDDWD7GK9086AAeB77G5WGYx5188iiRD7So+law5ciXdr3YsdIJfMjmfh8j/DS0llRdAODeolU1+AAHaO3//lgPr4MAduHemW/m9zjlDf523Gdhrdp+Fnc4pxcpzQHAvbm7E9cTrP+8agX4CLiD8s72b8cvUVffalkvUtsIAieCR3BH166dGtaW9+kZudpQ1julX4oCWOM8cKpoJwxYemvvsqkNAWIDEkDiSACJIwEkjgSQOBJA4kgAiSMBJI4EkDgSQOJIAIkjASSOBJA4EkDiSACJIwEkjgSQOBJA4kgAiSMBJI4EkDgSQOJIAIkjASSOBJA4FgFcNpTttToiWtJnKLvoW9AigHlD2WgZqxPGkthqzregRQAXDGVvNpQVftxkKDsTw4EeYAm//ABzQHcMJxKlG9emPm2/hCE/gJUxTycawJOxnEiQp/Bv99MxHXnH4MhZ1AvkQQ9bZzXZaKMxnXnI4EgDOBzTmUQ4iq3NH4jpTBdw0ejQ8zEdqjkvYGvrGVyMonLI6NRaT6DhwJ8e7L/8BvB6O5zbDVwKcO4s8AQSwlZ04yZ8ljF/zRZwuRBNhGaWfBN4NvDaOVxunh9xOfksG0x1ZAcwiFvn30/4LuprBAy3oQLow6VQNStORGECd3CV+ccU+jJoDtedLwdeL/JjBXiGwJ40S17Z33A9yN0Z7iGycwB4v6iHdxA2W5XlY0dahyg+ncB7FN8YqdkRImYGt9KB64rWn2cri2NLRMwInpU9hB/BKmttf+BOMCk1vbgdqZDNIllzWwBexS9beGkYAN4A/qT4BqyqzeB+TNH2W6KeMbNKF26HawR39NoNlGjyUjKWgZ9xB1ueAj7H9i2mmXYIYCPdwHXATlyXlvq7gUXcJs408CuGDzqFEEIIIYQQQgghhBDCj38BllEQL2Y8o/YAAAAASUVORK5CYII="
                    width="15"
                  />
                </div>
              </label>
              <span className="font-weight-bold fs-6">{vehicleDetails?.gpsLong || "-"}</span>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}

export default VehicleDetails;
